<!-- Selection -->
<p-dropdown
  #dropdown
  appendTo="body"
  [baseZIndex]="10500"
  [autoZIndex]="false"
  [styleClass]="
    'form-control ' +
    (class || '') +
    ' ' +
    selectClasses +
    (dropdownButton ? '' : 'no-trigger ') +
    (required && selectModel.invalid && selectModel.touched
      ? ' is-invalid'
      : '')
  "
  [ngClass]="{
    'is-invalid': required && selectModel.invalid && selectModel.touched,
  }"
  [options]="optionsArray"
  [optionValue]="getKeyField()"
  [optionLabel]="displayField"
  [filter]="true"
  [filterBy]="lazyLoad ? displayField : searchField"
  filterMatchMode="contains"
  [id]="key"
  [ngModel]="value ?? undefined"
  (ngModelChange)="valueChange.emit(checkValue($event))"
  [name]="key"
  #selectModel="ngModel"
  [emptyMessage]="
    isLoading
      ? ('Loading' | translate) + '...'
      : ('No result found' | translate)
  "
  [emptyFilterMessage]="'No result found' | translate"
  [placeholder]="
    isLoading ? ('Loading' | translate) + '...' : placeholder || ''
  "
  [showClear]="clearButton"
  [required]="required"
  [disabled]="disabled"
  [loading]="isLoading"
  (onFilter)="lazyLoad ? onFilter($event) : null"
  [class]="'text-left ' + (class || '')"
  [panelStyleClass]="'op-select-panel-' + key"
  (onShow)="onShow()"
  (onHide)="onHide()"
>
  <!-- Custom item template -->
  <ng-template let-item pTemplate="item">
    <ng-container
      *ngIf="itemTemplate; else simpleItem"
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }"
    ></ng-container>
    <ng-template #simpleItem>
      {{
        displayParser
          ? displayParser(item)
          : displayField
            ? (item | get: displayField)
            : item
      }}
    </ng-template>
  </ng-template>

  <!-- Custom selected item template -->
  <ng-template let-item pTemplate="selectedItem">
    <ng-container
      *ngIf="itemTemplate; else simpleSelectedItem"
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }"
    ></ng-container>
    <ng-template #simpleSelectedItem>
      {{
        displayParser
          ? displayParser(item)
          : displayField
            ? (item | get: displayField)
            : item
      }}
    </ng-template>
  </ng-template>
</p-dropdown>

<!-- Errors -->
<div
  *ngIf="selectModel.errors && selectModel.errors['required']"
  class="invalid-feedback"
>
  {{ requiredError }}
</div>
